import { render, staticRenderFns } from "./WishWindow.vue?vue&type=template&id=6628a8f3&lang=true&"
import script from "./WishWindow.vue?vue&type=script&lang=js&"
export * from "./WishWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports